import styled from 'styled-components';

import colors from '../../../theme/colors';
import media from '../../../theme/media';

export const SwiperContainer = styled.div`
    display: none;
    padding-bottom: 44px;
    position: relative;

    ${media.desktop1352} {
        display: flex;
    }
`;
export const SwiperWrapper = styled.div`
    box-sizing: content-box;
    display: none;
    height: 100%;
    justify-content: space-between;
    position: relative;
    width: 100%;
    z-index: 1;

    ${media.desktop1352} {
        display: flex;
    }
`;
export const SwiperSlide = styled.div`
    display: none;

    ${media.desktop1352} {
        display: flex;
        flex-direction: column;
        flex-shrink: 0;
        height: 100%;
        margin: 0;
        position: relative;
        width: calc(50% - 40px) !important;
    }
`;
export const Inner = styled.div`
    height: 100%;
    position: relative;
`;
export const FlickitySlide = styled.div`
    box-sizing: border-box;
    height: 684px;
    margin-right: 24px;
    min-width: 272px;
    padding: 6px 12px 18px;
    width: 100%;

    ${media.tablet648} {
        height: 784px;
        margin-right: 32px;
    }
`;
export const CrossProductBanner = styled.a`
    background-color: #fff;
    border: 1px solid rgba(159, 157, 163, 0.28);
    border-radius: 12px;
    box-shadow: 0 8px 12px rgba(20, 20, 20, 0.04);
    color: inherit;
    display: block;
    height: 660px;
    margin-left: auto;
    margin-right: auto;
    outline: none;
    text-decoration: none;

    &:focus-visible {
        outline: 1px dashed ${colors.lightGray};
    }

    ${media.tablet648} {
        border-radius: 16px;
        height: 760px;
    }
`;
export const CrossProductTitle = styled.div`
    display: -webkit-box;
    font-size: 24px;
    height: 72px;
    line-height: 36px;
    margin-bottom: 16px;
    max-height: 72px;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;

    ${media.tablet648} {
        font-size: 40px;
        height: 112px;
        line-height: 56px;
        max-height: 112px;
    }
`;
export const CrossProductDescription = styled.div`
    color: ${colors.mediumGray};
    display: -webkit-box;
    font-size: 17px;
    height: 96px;
    line-height: 24px;
    max-height: 96px;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;

    ${media.tablet648} {
        font-size: 20px;
        line-height: 32px;
        -webkit-line-clamp: 3;
    }
`;
export const TextContent = styled.div`
    padding: 72px 24px 0;
    text-align: center;

    ${media.tablet648} {
        padding: 72px 48px 0;
    }
`;
export const Link = styled.div`
    align-items: center;
    display: inline-flex;
    font-size: 17px;
    line-height: 24px;
    margin-top: 24px;

    ${media.tablet648} {
        font-size: 20px;
        line-height: 32px;
    }
`;
export const LearnMore = styled.span`
    color: ${colors.purple};
`;
export const Illustration = styled.figure`
    text-align: center;
    margin: 34px auto;
    padding: 0 1em;

    img {
        border: 0;
        max-width: 100%;
        vertical-align: top;
    }

    ${media.tablet648} {
        margin: 48px auto 72px;
    }
`;
export const Logos = styled.div`
    left: 20px;
    position: absolute;
    right: 20px;
    text-align: center;
    top: 16px;

    figure {
        display: inline-block;
        height: auto;
        width: 157px;

        img {
            border: 0;
            max-width: 100%;
            vertical-align: top;
        }
    }
`;
